import 'magnific-popup';
const $doc = $(document)

$('.js-popup-inline').magnificPopup({
  type: 'inline',
  preloader: false,
  mainClass: 'popup-default',
  fixedContentPos: true
});

$doc.on('click', '.js-popup-inline-close', function (e) {
  e.preventDefault();
  $.magnificPopup.close();
});
